<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q7W3Dm/tc-custom/9781453219096.jpg?1705807611652" alt="This image is the cover for the book Cardington Crescent, The Charlotte and Thomas Pitt Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cardington Crescent, The Charlotte and Thomas Pitt Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Charlotte Pitt defends her own sister against a murder charge in Victorian England, in a novel “suffused with atmosphere, emotion, and suspense” (<i>Booklist</i>).</b><br/>  As Inspector Thomas Pitt works to resolve the case of a dismembered woman, his womanizing brother-in-law, George March, Lord Ashworth, is poisoned with his morning coffee at the country estate of his cousins. The primary suspect? Charlotte’s sister, Emily, the murdered man’s wife and Pitt’s sister-in-law. Charlotte and Pitt take on the March clan with the help of Great-aunt Vespasia, their formidable relative and a member of the clan, to break through the wall of deceit and silence. When Sybilla March, George’s suspected paramour, is found strangled by her hair and Emily is the one who found her, the case would seem hopeless—for anyone but the indomitable Pitts. Their pursuit of the truth takes them down a path of corruption, depravity, and murder, from the elegant townhouses lining fashionable Cardington Crescent to the horrifying slums of London.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Perry
      </h2>
      
      <p class="authorDescription body article"> Anne Perry (1938&ndash;2023) was a bestselling author of historical detective fiction, most notably the Thomas and Charlotte Pitt series and the William Monk series, both set in Victorian England. Her first book,&#160;<I>The Cater Street Hangman</I>&#160;(1979), launched both the Pitt series and her career as a premier writer of Victorian mysteries. Other novels in the series include&#160;<I>Resurrection Row</I>,&#160;<I>Death in the Devil&rsquo;s Acre</I>, and&#160;<I>Silence in Hanover Close</I>, as well as more than twenty others. The William Monk series of novels, featuring a Victorian police officer turned private investigator, includes&#160;<I>Funeral in Blue</I>,&#160;<I>The Twisted Root</I>, and&#160;<I>The Silent Cry</I>. In addition to these series, Perry also authored the World War I novels&#160;<I>No Graves as Yet</I>,&#160;<I>Shoulder the Sky</I>,&#160;<I>Angels in the Gloom</I>, and others, as well as several collections of short stories. Perry&rsquo;s novels have appeared on bestseller lists around the world and have sold more than twenty-five million books in print worldwide.<BR /> &#160; </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43dc83a6